<template>
    <div>
      <button @click="abrirGrafana">Abrir Grafana</button>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      abrirGrafana() {
        const grafanaWindow = window.open(
          'https://acgsaas.ual.es/grafana/public-dashboards/2b05248030cc44e8a412b295f969f12b?orgId=1&refresh=5m',
          '_blank'
        );
        
        // Esto solo funciona si tienes control de la página abierta, lo cual no es tu caso.
        // grafanaWindow.postMessage("Hola desde la app", "*");
      }
    }
  };
  </script>
  